'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canReadText = canReadText;

var _hexToRgb2 = require('./hexToRgb');

function getLightness(hex) {
  var _hexToRgb = (0, _hexToRgb2.hexToRgb)(hex),
      rRaw = _hexToRgb.r,
      gRaw = _hexToRgb.g,
      bRaw = _hexToRgb.b;

  var r = rRaw / 255.0;
  var rLightness = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);

  var g = gRaw / 255.0;
  var gLightness = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);

  var b = bRaw / 255.0;
  var bLightness = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

  return 0.2126 * rLightness + 0.7152 * gLightness + 0.0722 * bLightness;
}

function canReadText(backgroundHex, textColor) {
  var backLightness = getLightness(backgroundHex);
  var textLightness = getLightness(textColor);

  var contrastRatio = (textLightness + 0.05) / (backLightness + 0.05);

  return contrastRatio > 2.0;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-messages/static-1.640/js/util/canReadText.js
// module id = 1093
// module chunks = 2 3